"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var controls = {
  id: "faqControls",
  title: {
    en: "Controls",
    de: "Steuerung"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q1: How do I change views?"), /*#__PURE__*/_react.default.createElement("p", null, "A: Press 'F12' or L_Click the change view icon. Supported views are 3rd person free view, 3rd person back view, 1st person view, and mouse mode."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q2: How do I move in keyboard mode?"), /*#__PURE__*/_react.default.createElement("p", null, "A: Use the W, S, A, D keys to mobilize your character. Refer to the movement tab located at the top of screen."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q3: It's hard for me to move item by item when looting. Is there any other way to loot?"), /*#__PURE__*/_react.default.createElement("p", null, "A: R_Click on the item you want to move and it will instantly move the items from inventory to inventory."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q4: Any tips when mobilizing the in-game camera?"), /*#__PURE__*/_react.default.createElement("p", null, "A: The basic method is to hold the R_mouse button and move your mouse around. This function is also matched with the arrow keys on your keyboard. Clicking the mouse wheel will instantly give you a 180 degree turn around view."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q5: When traveling distances, it is tiring pressing 'W' continuously. Is there any other way?"), /*#__PURE__*/_react.default.createElement("p", null, "A: The 'Tab' key is the answer. You can stop by pressing the same key. Please note that this does not work while you are in mouse mode."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q6: Is there any hotkey to select party members?"), /*#__PURE__*/_react.default.createElement("p", null, "A: Hotkeys to target party members are not defined as default. However, It is possible through the hotkey option in the main option menu. Or, you can simply click on the name of a party member from the party window. If you want to share the target (targeting the same object that the player has targeted), press 'ctrl' and L_Click on the name of the player from the party window."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q7: How do I see buff info of other party members?"), /*#__PURE__*/_react.default.createElement("p", null, "A: Click the class mark near the party member's name. Little buff icons will display on the right hand side of each name. These buff icons are small, but you can see explanations for each buff once you place the cursor over it."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q8: How do I register skills to quick slots?"), /*#__PURE__*/_react.default.createElement("p", null, "A: You must learn the skill you want to register. Once learned, the icon will become brighter. You can then take the icon out by L_Clicking and placing it into the selected slot. Slots 1 to 8 are matched to hotkeys 1 to 8, or you can R_Click onto the icon you want to use."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q9: There is a tab for using continuous skills in the skill window, but the skills there do not register onto quick slots and I cannot use them. What should I do?"), /*#__PURE__*/_react.default.createElement("p", null, "A: Continuous skills are not learned, but are a set of skills from the skill window. You must learn all the skills required first then cast the first skill of the skill set. Once you see a clock like gauge above your character, you must press 'L_Shift' to cast the second skill, third skill and so on."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#BC6E13"
      }
    }, "Q10: When I press 'L_Shift' key to cast continuous skills, the screen goes to Windows and tells me to set fixed key. What should I do?"), /*#__PURE__*/_react.default.createElement("p", null, "A: MS Windows\xAE supports the 'fixed key' function in order to support easier use of keys used most often. If this function is enabled, it makes hard to cast continuous skills in Ferentus. Please go to Windows 'control panel' and choose 'option needed for me', and disable the 'use fixed key' option."))
  }
};
var _default = controls;
exports.default = _default;